import { Module } from "vuex";
import { RootState, SearchState } from "@/types/search";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: SearchState = {
  recommendRecipes: null,
  rankingRecipes: null,
  searchKeywordRecipes: null,
  tagGroups: null,
  products: null,
  keyword: null,
  sortType: null,
  tags: null,
  applianceList: null
};

export const search: Module<SearchState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
